/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import { Statistic } from 'semantic-ui-react'
import { RateRadialChart } from '../Shared/RateRadialChart'

const getRateColor = (rate) => {
    if (rate === 0) return '#e5e7eb'
    if (rate >= 70) return 'green'
    if (rate >= 50) return 'orange'
    return 'red'
}

const DisputesSummaryHeader = ({
    isMobile,
    autoRecoverableRate,
    totalRecoveredAmount,
    totalDisputeAmount,
    totalUnrecoveredAmount,
    recoveryRate,
    formatMoney,
    t,
}) => (
    <div
      css={css`
          display: grid;
          grid-template-areas: ${isMobile ? '"middle" "left" "right"' : '"left middle right"'};
          grid-template-columns: ${isMobile ? '1fr' : '1fr 1.3fr 1fr'};
          align-items: stretch;
          row-gap: 1rem;
          column-gap: 1.5rem;
      `}
    >
        <div
          css={css`
              grid-area: left;
              justify-self: center;
              align-self: stretch;
              display: flex;
              height: 100%;
              align-items: center;
              justify-content: center;
          `}
        >
            <RateRadialChart
              rate={autoRecoverableRate}
              animationsEnabled
              label={t('dispute.automatic_recovery_rate')}
              getColor={getRateColor}
            />
        </div>

        <div
          css={css`
              grid-area: middle;
              justify-self: center;
              align-self: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: .5rem;
          `}
        >
            <Statistic
              color={totalRecoveredAmount > 0 ? 'green' : undefined}
              size="small"
              css={css`
                  margin: 0 !important;
                  text-align: center;
              `}
            >
                <Statistic.Value>{formatMoney(totalRecoveredAmount)}</Statistic.Value>
                <Statistic.Label>{t('dispute.total_recovered')}</Statistic.Label>
            </Statistic>

            <div
              css={css`
                  display: flex;
                  gap: 1.5rem;
                  align-items: flex-start;
                  justify-content: center;
                  flex-wrap: wrap;
                  text-align: center;

                  & .ui.statistic,
                  & .ui.statistic + .ui.statistic {
                      margin: 0;
                  }

                  & .ui.statistic > .value {
                      font-size: 1.2rem !important;
                  }

                  & .ui.statistic > .label {
                      font-size: .8rem !important;
                  }
              `}
            >
                <Statistic color={totalDisputeAmount > 0 ? 'red' : undefined} size="mini">
                    <Statistic.Value>{formatMoney(totalDisputeAmount)}</Statistic.Value>
                    <Statistic.Label>{t('dispute.total_disputed')}</Statistic.Label>
                </Statistic>

                <Statistic color={totalUnrecoveredAmount > 0 ? 'red' : undefined} size="mini">
                    <Statistic.Value>{formatMoney(totalUnrecoveredAmount)}</Statistic.Value>
                    <Statistic.Label>{t('dispute.total_unrecovered')}</Statistic.Label>
                </Statistic>
            </div>
        </div>

        <div
          css={css`
              grid-area: right;
              justify-self: center;
              align-self: stretch;
              display: flex;
              height: 100%;
              align-items: center;
              justify-content: center;
          `}
        >
            <RateRadialChart
              rate={recoveryRate}
              animationsEnabled
              label={t('dispute.recovery_rate')}
              getColor={getRateColor}
            />
        </div>
    </div>
)

export default DisputesSummaryHeader
